import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ApplicationId } from 'yeself-common/typings/application/Application';

import {
    rolloutPoliciesByMyOrganizationsRequest,
    rolloutPoliciesBySpaceIdRequest,
    updateApplicationExtensionUrlsRequest,
} from 'Console/data/applicationDetail/settings/SettingsAction';

import {
    selectAvailableRolloutPolicies,
    selectExtensionUrls,
} from 'Console/data/applicationDetail/settings/SettingsSelector';

import { ExtensionUrl } from 'Console/data/applicationDetail/settings/types';

import OriginUrlsForm from './OriginUrlsForm';

type OriginUrlsProps = {
    applicationId: ApplicationId;
};

const OriginUrls = ({ applicationId }: OriginUrlsProps): React.ReactElement => {
    const dispatch = useDispatch();

    const extensionUrls = useSelector(selectExtensionUrls);
    const availableRolloutPolicies = useSelector(selectAvailableRolloutPolicies);

    useEffect(() => {
        dispatch(rolloutPoliciesByMyOrganizationsRequest());
        dispatch(rolloutPoliciesBySpaceIdRequest());
    }, [dispatch]);

    const handleOnChange = useCallback(
        (value: ExtensionUrl[]) => {
            dispatch(updateApplicationExtensionUrlsRequest(applicationId, value));
        },
        [dispatch, applicationId]
    );

    return (
        <OriginUrlsForm
            initialValue={extensionUrls}
            availableRolloutPolicies={availableRolloutPolicies}
            onChange={handleOnChange}
        />
    );
};

export default OriginUrls;
